<template>
  <div class="w-full h-full flex relative overflow-hidden">
    <div class="p-5 flex flex-1 bg- gap-4 flex-wrap content-start">
      <div
        v-for="item in list"
        :key="item.c"
        @click="$router.push({ query: { c: item.c } })"
        class="flex flex-col justify-center items-center cursor-pointer hover:shadow-lg duration-200 bg-white border border-gray-200 shadow-sm rounded-lg p-4 w-64 h-64"
      >
        {{ item.c }}
      </div>
    </div>
    <div
      class="absolute left-0 top-0 bg- w-full h-full flex"
      style="background: #f8f8f8"
      v-if="!isMainPage"
    >
      <component :is="$route.query.c" ref="component"></component>
      <MapViewX v-if="$route.query && $route.query.c == 'MapView'" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

const route = useRoute();

const isMainPage = computed(() => {
  return route.query ? (route.query.c ? false : true) : true;
});

const list = [
  {
    c: 'MapView',
  },
  {
    c: 'TableViewPage',
  },
  { c: 'HybridView' },
  { c: 'MultiView' },
  { c: 'PlayBack' },
  { c: 'ChangeLogsPage' },
  { c: 'MaintenancePage' },
  { c: 'FuseSelectPage' },
];
</script>
<script>
import MapView from './map-view/MapView.vue';
import MapViewX from './map-view-x/MapViewX.vue';
import TableViewPage from './table-view/TableViewPage.vue';
import HybridView from './hybrid-view/HybridView.vue';
import MultiView from './multi-view/MultiView.vue';
import PlayBack from './playback/PlayBack.vue';
import ChangeLogsPage from './changelogs/ChangeLogsPage.vue';
import MaintenancePage from './maintenance/MaintenancePage.vue';
import FuseSelectPage from './fuse-select/FuseSelectPage.vue';

export default {
  components: {
    MapView,
    MapViewX,
    TableViewPage,
    HybridView,
    MultiView,
    PlayBack,
    ChangeLogsPage,
    MaintenancePage,
    FuseSelectPage,
  },
};
</script>

<style scoped></style>
